var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { memo } from 'react';
import { Image } from 'pcln-design-system';
import { trimAssetUrl } from '../utils';
/** @public */
var ContentfulImage = function (_a) {
    var _b;
    var altText = _a.altText, asset = _a.asset, className = _a.className, desktopFocalPoint = _a.desktopFocalPoint, fit = _a.fit, _c = _a.format, format = _c === void 0 ? 'webp' : _c, height = _a.height, _d = _a.quality, quality = _d === void 0 ? 80 : _d, radius = _a.radius, width = _a.width, rest = __rest(_a, ["altText", "asset", "className", "desktopFocalPoint", "fit", "format", "height", "quality", "radius", "width"]);
    var assetAltText = (asset === null || asset === void 0 ? void 0 : asset.description) || (asset === null || asset === void 0 ? void 0 : asset.title);
    var file = asset === null || asset === void 0 ? void 0 : asset.file;
    var url = trimAssetUrl(file === null || file === void 0 ? void 0 : file.url);
    var dimensions = ((_b = file === null || file === void 0 ? void 0 : file.details) === null || _b === void 0 ? void 0 : _b.image) || {};
    var h = height || dimensions.height;
    var w = width || dimensions.width;
    var heightPixels = h ? "".concat(h, "px") : null;
    var widthPixels = w ? "".concat(w, "px") : null;
    if (!url)
        return null;
    var imageParams = __assign(__assign(__assign(__assign(__assign(__assign(__assign({}, (fit && { fit: fit })), (desktopFocalPoint && { f: desktopFocalPoint })), (!url.includes('.svg') && { fm: format })), (radius && { r: radius })), (width && { w: width })), (height && { h: height })), { q: quality });
    var imageParamsKeys = Object.keys(imageParams);
    var imageParamString = "?".concat(imageParamsKeys.map(function (key) { return "".concat(key, "=").concat(imageParams[key]); }).join('&'));
    var src = "https:".concat(url).concat(imageParamString);
    return (React.createElement(Image, __assign({ src: src, alt: altText || assetAltText, height: heightPixels, width: widthPixels, className: className }, rest)));
};
export default memo(ContentfulImage);
//# sourceMappingURL=ContentfulImage.js.map